export const AI_PANEL_MODULE_ID = 'ai-panel-module';

export const LOAD_AI_PANEL_MODULE = () => import('@capital-access/ai-panel/client').then(m => m.AiPanelModule);
